import script from "./AppVueDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AppVueDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./AppVueDatePicker.vue?vue&type=style&index=0&id=3f9149f2&lang=scss"

const __exports__ = script;

export default __exports__